// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"589":"37ba5b8d00b85f9df850","678":"fd042b4b0eb42269a189","883":"d205339c83248edadc15"}[chunkId] + ".js";
};